import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
var _excluded = ["children", "className", "inputClassName", "type", "hasError", "inputRef", "autoComplete"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React from 'react';
import PropTypes from 'prop-types';
import omit from 'lodash/fp/omit';
import isNil from 'lodash/fp/isNil';
import isEmpty from 'lodash/fp/isEmpty';
import classNames from 'classnames';
export var DEFAULT_TYPE = 'text';
export var SUPPORTED_TYPES = ['text', 'password', 'email'];
var ClearableInput = /*#__PURE__*/function (_React$Component) {
  _inherits(ClearableInput, _React$Component);
  var _super = _createSuper(ClearableInput);
  function ClearableInput(props) {
    var _this;
    _classCallCheck(this, ClearableInput);
    _this = _super.call(this, props);
    var initialValue = props.value || props.defaultValue || '';
    _this.state = {
      inputValue: initialValue,
      showClear: _this.hasValue(initialValue),
      // Note: check for null and undefined not for empty string
      isControlled: !isNil(props.value)
    };
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
    _this.handleKeyPress = _this.handleKeyPress.bind(_assertThisInitialized(_this));
    _this.clearInputValue = _this.clearInputValue.bind(_assertThisInitialized(_this));
    return _this;
  }

  // only gets triggered on user interaction.
  _createClass(ClearableInput, [{
    key: "handleChange",
    value: function handleChange(event) {
      var isControlled = this.state.isControlled;
      var onChange = this.props.onChange;
      var value = event.target.value;
      if (isControlled) {
        onChange(value, event);
      } else {
        this.changeInternalValue(value, event);
        onChange(value, event);
      }
    }

    // Will be triggered on every key press but also when pressing 'Enter' for example
  }, {
    key: "handleKeyPress",
    value: function handleKeyPress(event) {
      var onKeyPress = this.props.onKeyPress;
      onKeyPress(event);
    }

    // important for when used as a controlled component (value from outside).
    // eslint-disable-next-line camelcase
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      this.changeInternalValue(nextProps.value);
    }
  }, {
    key: "hasValue",
    value: function hasValue(value) {
      return !isEmpty("".concat(value));
    }

    // handles new input value and saves it in the state.
    // the value stored in the state is used for rendering.
  }, {
    key: "changeInternalValue",
    value: function changeInternalValue() {
      var _this2 = this;
      var newValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      // this is there to prevent that onChange and UNSAFE_componentWillReceiveProps set state at the same time
      if (this.state.inputValue === newValue) {
        return;
      }
      this.setState(function () {
        return {
          inputValue: newValue,
          showClear: _this2.hasValue(newValue)
        };
      });
    }
  }, {
    key: "clearInputValue",
    value: function clearInputValue(event) {
      var _this$props = this.props,
        onChange = _this$props.onChange,
        onClear = _this$props.onClear;
      this.changeInternalValue('', event);
      onChange('', event);
      if (onClear) {
        onClear(event);
      }
    }

    // it is always the value from the state which is used for rendering.
    // reason: make it possible to use the component as a controlled or uncontrolled component.
    // https://facebook.github.io/react/docs/uncontrolled-components.html
  }, {
    key: "render",
    value: function render() {
      var filteredProps = omit(['value', 'defaultValue', 'onClear']);
      var _this$props2 = this.props,
        children = _this$props2.children,
        className = _this$props2.className,
        inputClassName = _this$props2.inputClassName,
        type = _this$props2.type,
        hasError = _this$props2.hasError,
        inputRef = _this$props2.inputRef,
        autoComplete = _this$props2.autoComplete,
        customProps = _objectWithoutProperties(_this$props2, _excluded);
      var _this$state = this.state,
        showClear = _this$state.showClear,
        inputValue = _this$state.inputValue;
      var classes = classNames('ClearableInput', 'input-group', hasError && 'has-error', className && className);
      var inputClassNames = classNames('form-control', inputClassName, showClear && 'withClearButton');
      var clearButtonClassNames = classNames('clearButton', !showClear && 'hide');
      var convertedType = type && type.toLowerCase();
      var inputType = SUPPORTED_TYPES.indexOf(convertedType) !== -1 ? convertedType : DEFAULT_TYPE;
      var inputProps = _objectSpread(_objectSpread({}, filteredProps(customProps)), {}, {
        className: inputClassNames,
        type: inputType,
        value: inputValue,
        onChange: this.handleChange,
        onKeyPress: this.handleKeyPress,
        // ref={this.props.innerRef} is the equivalent of forwardRef
        ref: inputRef || this.props.innerRef,
        autoComplete: autoComplete
      });
      return /*#__PURE__*/React.createElement("div", {
        className: classes
      }, children ? children(inputProps) : /*#__PURE__*/React.createElement("input", inputProps), /*#__PURE__*/React.createElement("span", {
        className: clearButtonClassNames,
        onClick: this.clearInputValue
      }, /*#__PURE__*/React.createElement("span", {
        className: 'clearButtonIcon rioglyph rioglyph-remove-sign'
      })));
    }
  }]);
  return ClearableInput;
}(React.Component);
ClearableInput.defaultProps = {
  type: DEFAULT_TYPE,
  className: '',
  inputClassName: '',
  hasError: false,
  tabIndex: 0,
  onChange: function onChange() {},
  onBlur: function onBlur() {},
  onFocus: function onFocus() {},
  onKeyPress: function onKeyPress() {}
};
ClearableInput.propTypes = {
  className: PropTypes.string,
  inputClassName: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func,
  onClear: PropTypes.func,
  onKeyPress: PropTypes.func,
  placeholder: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  type: PropTypes.oneOf(SUPPORTED_TYPES),
  defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  maxLength: PropTypes.number,
  tabIndex: PropTypes.number,
  hasError: PropTypes.bool,
  inputRef: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  autoComplete: PropTypes.string
};
export default ClearableInput;